// ============================================================================
// PORTUGUESE TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Tesouros espirituais extraídos da Palavra

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "A sabedoria divina não é teoria abstrata, mas vida concreta que se manifesta em nossas escolhas diárias",
    reference: "Provérbios 3:13-18",
    category: "sabedoria",
    strongNumbers: {
      "sabedoria": "H2451", // חָכְמָה (chokmah) = sabedoria prática
      "entendimento": "H8394" // תְּבוּנָה (tebunah) = discernimento
    },
    reflection: "Como posso aplicar a sabedoria divina em minhas decisões hoje?"
  },
  {
    type: "tresor_divine",
    content: "O amor de Deus não é condicional aos nossos méritos, mas um presente eterno que flui de Sua própria natureza",
    reference: "Romanos 8:38-39",
    category: "amor",
    strongNumbers: {
      "amor": "G26", // ἀγάπη (agape) = amor incondicional
      "separar": "G5563" // χωρίζω (chorizo) = separar
    },
    reflection: "Nada pode nos separar do amor de Deus revelado em Cristo"
  },
  {
    type: "lumiere_vie",
    content: "Jesus é a luz que ilumina não apenas nosso caminho, mas também nosso ser interior",
    reference: "João 8:12",
    category: "identidade",
    strongNumbers: {
      "luz": "G5457", // φῶς (phos) = luz
      "vida": "G2222" // ζωή (zoe) = vida abundante
    },
    reflection: "Como deixo a luz de Cristo iluminar minhas áreas de escuridão?"
  },
  {
    type: "force_divine",
    content: "Nossa força não vem de nós mesmos, mas dAquele que habita em nós",
    reference: "Efésios 3:16-17",
    category: "poder",
    strongNumbers: {
      "fortalecidos": "G2901", // κραταιόω (krataioo) = fortalecer
      "poder": "G1411" // δύναμις (dynamis) = poder divino
    },
    reflection: "Em meus momentos de fraqueza, confio na força de Deus?"
  },
  {
    type: "paix_profonde",
    content: "A paz de Deus não depende de circunstâncias externas, mas de Sua presença constante em nossos corações",
    reference: "Filipenses 4:6-7",
    category: "serenidade",
    strongNumbers: {
      "paz": "G1515", // εἰρήνη (eirene) = paz completa
      "guardará": "G5432" // φρουρέω (phroureo) = guardar como fortaleza
    },
    reflection: "Como cultivo a paz de Deus que excede todo entendimento?"
  },
  {
    type: "esperance_vivante",
    content: "Nossa esperança não é um desejo incerto, mas uma âncora sólida fundamentada nas promessas fiéis de Deus",
    reference: "Hebreus 6:19",
    category: "esperança",
    strongNumbers: {
      "esperança": "G1680", // ἐλπίς (elpis) = esperança confiante
      "âncora": "G45" // ἄγκυρα (ankyra) = âncora da alma
    },
    reflection: "Em quais promessas de Deus ancoro minha esperança hoje?"
  },
  {
    type: "transformation",
    content: "A transformação espiritual é um processo contínuo onde nos tornamos cada dia mais à imagem de Cristo",
    reference: "2 Coríntios 3:18",
    category: "crescimento",
    strongNumbers: {
      "transformados": "G3339", // μεταμορφόω (metamorphoo) = transformar completamente
      "glória": "G1391" // δόξα (doxa) = glória divina
    },
    reflection: "Quais áreas da minha vida precisam de transformação hoje?"
  }
];

export default bibleTreasures;
